/* eslint-disable */

import "../vendor//placeholder";

(function () {
  "use strict";

  // require("vendor/placeholder");

  $("input, textarea").placeholder();
})();
